import axios from "axios"
import {Toast} from "vant";
import router from "../router/index"
import qs from "qs"
export default {
    data() {
        return {

        }
    },
    created: function () {

    },
    mounted: function () {

    },
    methods: {
      get: (url, queryData) => {
        return new Promise((resolve,reject)=>{
          axios.defaults.transformRequest = function (data) {
            data = qs.stringify(data);
            return data;
          };
          axios
            .get(url, {params:queryData,timeout:3000})
            .then(response => {
              resolve(response)
            })
            .catch(err => {
              console.log(err)
              reject(err)
            })
        })
      },
      post: (url ,post ) =>{
       return new Promise((resolve,reject)=>{
         axios.defaults.transformRequest = function (data) {
           data = qs.stringify(data);
           return data;
         };
         axios
           .post(url, post)
           .then(response => {
             resolve(response)
           })
           .catch(err => {
             reject(err)
           })
       })
      },
        fetchData: (url, queryData, callback) => {
          axios.defaults.transformRequest = function (data) {
            data = qs.stringify(data);
            return data;
          };
            axios
                .get(url, {params:queryData})
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        fetchDataPost: function (url ,post ,callback) {
          axios.defaults.transformRequest = function (data) {
            data = qs.stringify(data);
            return data;
          };
            axios
                .post(url, post)
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        upload(url,file,data,callback){
            let fileData = new FormData();
            //fileData.append('file[]',file)
            for(let i in file){
                fileData.append('file[]',file[i],file[i].name)
            }
            if(!data) data = {}
            data.openid = sessionStorage.getItem('token');
            data.appid = sessionStorage.getItem('appid');
           /* fileData.append('file',file[0])
            fileData.append('file',file[1])*/
            for(let i in data){
                fileData.append(i,data[i]);
            }
            const config = {
                headers: { "Content-Type": "multipart/form-data" }
            };
            axios.defaults.transformRequest = function (data) {
                return data;
            }
            axios.post(url, fileData,config)
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Toast.clear()
                    Toast.fail('system error post');
                })
        },
        async uploadsync(url,file){
          let fileData = new FormData();
          fileData.append('file',file)
          const config = {
            headers: { "Content-Type": "multipart/form-data" }
          };
          axios.defaults.transformRequest = function (data) {
            return data;
          }
          let res = await axios.post(url, fileData,config)
          return res
        },
        onClickLeft(){
            router.go(-1)
        },
        goHome(){
            router.push({name:'home'})
        },
      routerBack(){
        router.back()
      }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/do_request.js